import ConsignmentStock from "../../models/ConsignmentStock"
import bus from "../../services/bus"

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000

export default {
  data() {
    return {
      loading: false,
      timer: undefined,

      consignmentStock: {
        image: {},
        monument: {},
      },

      title: "",
      items: [],
      takePicture: false,
    }
  },

  computed: {
    status() {
      switch (this.consignmentStock.status) {
        case "ordered":
          return { color: "grey", icon: "schedule", title: "Commandé", subtitle: "Le", date: "ordered_on" }
        case "shipping":
          return { color: "grey", icon: "local_shipping", title: "En livraison", subtitle: "Prévue le", date: "shipping_on" }
        case "delivered":
          return { color: "success", icon: "local_shipping", title: "Livré", subtitle: "Le", date: "shipping_on" }
        case "renewable":
          return { color: "error", icon: "schedule", title: "À renouveler", subtitle: "Échu le", date: "due_on" }
        case "renewed":
          return { color: "success", icon: "schedule", title: "Renouvelé", subtitle: "Le", date: "renewed_on" }
        case "billable":
          return { color: "error", icon: "picture_as_pdf", title: "À facturer", subtitle: "Échu le", date: "due_on" }
        case "billing":
          return { color: "success", icon: "picture_as_pdf", title: "Facturation demandée", subtitle: "Le", date: "billing_on" }
      }
      return {}
    },

    placement() {
      switch (this.consignmentStock.placement) {
        case "unknown":
          return { color: "grey", icon: "not_listed_location", title: "Placement", subtitle: "Inconnu" }
        case "pallet":
          return { color: "error", icon: "place", title: "Placement", subtitle: "Sur palette" }
        case "exposition":
          return { color: "success", icon: "place", title: "Placement", subtitle: "En exposition" }
      }
      return {}
    },

    image() {
      if (this.consignmentStock.image.taken_on) {
        const takenOn = new Date(this.consignmentStock.image.taken_on).getTime()
        if (takenOn < (Date.now() - MILLISECONDS_PER_DAY * 90)) {
          return { color: "error", title: "Photo prise il y a plus de 90 jours" }
        } else {
          return { color: "success", title: "Photo prise (moins de 90 jours)" }
        }
      } else {
        return { color: "error", title: "Pas de photo !" }
      }
    },
  },

  mounted() {
    this.load()
  },

  methods: {
    async load() {
      this.onLoading()
      let consignmentStock = await ConsignmentStock.find(this.$route.params.id)

      // FIXME: for some reason on page load the consignment stock is NEVER
      // found, but there is no problem on page navigation...
      if (consignmentStock) {
        this.consignmentStock = consignmentStock
        let items = this.consignmentStock.description.trim().split("\n")
        this.title = items.shift()
        this.items = items
      } else {
        this.title = ""
        this.items.length = 0
      }

      this.stopLoading()
    },

    uploadPicture(event) {
      this.takePicture = false

      const files = event.target.files || event.dataTransfer.files

      if (files.length) {
        let body = new FormData()
        body.set("image_taken_on", (new Date()).toISOString().split("T")[0])
        body.set("image", files[0])

        this.onLoading()

        ConsignmentStock
          .update(this.consignmentStock.id, body)
          .then(data => this.onUpdate(data, "La photo a été envoyée"))
          .catch(reason => this.onUpdateError(reason))
      }
    },

    onLoading() {
      this.timer = setTimeout(() => this.loading = true, 100)
    },

    stopLoading() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.loading = false
    },

    onUpdate(data, successMessage) {
      if (data) {
        Object.assign(this.consignmentStock, data)
      }
      bus.$emit("notification:success", successMessage || "Le dépot vente a bien été mis à jour")
      this.stopLoading()
    },

    onUpdateError(reason) {
      bus.$emit("notification:error", `Erreur : ${reason.message}`)
      this.stopLoading()
    },
  },

  directives: {
    doClick: {
      update(el, binding, vnode) {
        if (!binding.value) return
        el.click()
        vnode.context[binding.expression] = false
      },
    },
  },
}
